import React, { useEffect, useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SnippetsOutlined,
  FormOutlined
} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import Points from './modules/points';
import PointsUpdate from './modules/PointsUpdate';
import { Route, Routes, useNavigate } from 'react-router-dom';
import logo from './assets/logo/accutouch.png'
import logoIami from './assets/logo/iami.png'
import { Footer } from 'antd/es/layout/layout';
const { Header, Sider, Content } = Layout;
const App = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false)

  const items = [
    {
      key: '0',
      icon: <SnippetsOutlined />,
      label: 'Points',
      link: '/'
    },
    {
      key: '1',
      icon: <FormOutlined />,
      label: 'Add Points',
      link: '/points-update'
    }
  ]
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  useEffect(() => {
    window.addEventListener("resize", handleResize)
  })
  const handleResize = () => {
    if (window.innerWidth < 720) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }
  return (
    <Layout>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="demo-logo-vertical">
          {isMobile ? <img style={{ height: 'inherit' }} src={logoIami} /> : <img style={{ height: 'inherit' }} src={logo} />}
        </div>

        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['0']}
          onClick={(item) => {
            let route = items[item.key].link;
            navigate(route)
          }}
          style={{
            flex: 1,
            minWidth: 0,
          }}
          items={items}
        />
      </Header>
      {/* <Sider breakpoint="sm" trigger={null}
        onBreakpoint={(broken) => {
          if (broken === true) {
            setCollapsed(true)
          } else {
            setCollapsed(false)
          }
        }}
        collapsible
        collapsed={collapsed}>
        <div className="demo-logo-vertical">
         {collapsed ? <img style={{height:'inherit'}} src={logoIami} /> : <img style={{height:'inherit'}} src={logo} />} 
        </div>

        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['0']}
          onClick={(item) => {
            let route = items[item.key].link;
            navigate(route)
          }}
          items={items}
        />
      </Sider> */}
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {/* <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          /> */}
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: '85vh',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >

          <Routes>
            <Route path="/" element={<Points />} />
            <Route path="/points-update" element={<PointsUpdate />} />
          </Routes>

        </Content>
        <Footer
          style={{
            textAlign: 'center',
          }}
        >
          Accutouch Points ©{new Date().getFullYear()} Created by Sushant Mahalingpur
        </Footer>
      </Layout>
    </Layout>
  );
};
export default App;